import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { PUBLIC_CENTRES } from "../data/content";

export const TrainingCentres = () => (
  <section id="centres" className="py-24 sm:py-32 scroll-mt-16" data-testid="centres-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>Our Training Centres</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-3xl">
          Two centres. One <span className="text-[#D4AF37]">Zavi standard.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-5 sm:gap-6">
        {PUBLIC_CENTRES.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.08}>
            <article className="group border border-white/10 bg-[#050505] overflow-hidden hover:border-[#D4AF37]/40 transition-colors duration-300 flex flex-col h-full"
                     data-testid={`centre-${c.id}`}>
              <div className="relative aspect-[16/11] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.school} — Zavi FC training centre`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute inset-0 p-5 sm:p-6 flex flex-col justify-end">
                  <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-bold">{c.label} · {c.sector}</p>
                  <h3 className="font-heading text-xl sm:text-2xl font-black uppercase tracking-tight mt-2 leading-tight">{c.school}</h3>
                  <p className="text-white/60 text-xs mt-1">{c.city}</p>
                </div>
              </div>
              <div className="p-6 sm:p-7 flex flex-col flex-1">
                <p className="font-heading text-lg font-black uppercase tracking-tight text-[#D4AF37]">{c.tagline}</p>
                <div className="mt-4 space-y-3">
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold">Facility</p>
                    <p className="text-white/80 text-sm mt-1">{c.facility}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold">Best suited for</p>
                    <p className="text-white/80 text-sm mt-1">{c.suited}</p>
                  </div>
                </div>
                <a href={c.map} target="_blank" rel="noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-[#D4AF37] text-xs font-bold uppercase tracking-widest hover:gap-3 transition-all"
                  data-testid={`centre-map-${c.id}`}>
                  View on Map <ArrowUpRight size={13} />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
